/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import AppointmentSelect from './AppointmentSelect/index'
import CreateTreatmentAction from './CreateTreatmentAction/index'
import DateSelect from './DateSelect/index'
import DurationInput from './DurationInput/index'
import LocationSelect from './LocationSelect/index'
import MarkAsEmergency from './MarkAsEmergency/index'
import Notes from './Notes/index'
import NotesInput from './NotesInput/index'
import Options from './Options/index'
import React from 'react'
import SlotSelect from './SlotSelect/index'
import TemplateSelect from './TemplateSelect/index'
import TreatmentSelect from './TreatmentSelect/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import UntemplatedSlot from './UntemplatedSlot/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/AppointmentOverlay/Content/Form/Content"
  
}) {
let appointmentOverlayPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_id',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let appointmentOverlayValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_overlay',
format: fromHelpers.showCreateTreatmentAction,
})
let appointmentOverlayValueData1 = fromData.useDataFormat({ viewPath,
context: 'appointment_overlay',
format: fromHelpers.showFields,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let appointmentOverlayValueData2 = fromData.useDataFormat({ viewPath,
context: 'appointment_overlay',
format: fromHelpers.showAppointmentSelect,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let appointmentOverlayValueData3 = fromData.useDataFormat({ viewPath,
context: 'appointment_overlay',
format: fromHelpers.showMarkAsEmergency,
})
let appointmentOverlayAppointmentTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'appointment_type_id',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let tabSchedulingUntemplatedSlotDateValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'scheduling.untemplated_slot.date',
})
  return (<React.Fragment
>
<fromFlow.When is={appointmentOverlayPatientIdValueData}>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TreatmentSelect
  viewPath={`${viewPath}/TreatmentSelect`}
/>
</div>
</div>
</fromFlow.When>
<fromFlow.When is={appointmentOverlayValueData}>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<CreateTreatmentAction
  viewPath={`${viewPath}/CreateTreatmentAction`}
/>
</div>
</fromFlow.When>
<fromFlow.When is={appointmentOverlayValueData1}>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<fromFlow.When is={appointmentOverlayValueData2}>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Appointments"
/>
</div>
<AppointmentSelect
  viewPath={`${viewPath}/AppointmentSelect`}
/>
</div>
</fromFlow.When>
<fromFlow.When is={appointmentOverlayValueData3}>
<div
  data-testid="Content.Vertical:4"
  data-view-path={viewPath}
 className="views-block"
>
<MarkAsEmergency
  viewPath={`${viewPath}/MarkAsEmergency`}
/>
</div>
</fromFlow.When>
<div
  data-testid="Content.Vertical:5"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Type"
/>
</div>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal3}`}
>
<div
  data-testid="Content.Vertical:6"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical4}`}
>
<TemplateSelect
  viewPath={`${viewPath}/TemplateSelect`}
/>
</div>
<div
  data-testid="Content.Vertical:7"
  data-view-path={viewPath}
 className="views-block"
>
<DurationInput
  viewPath={`${viewPath}/DurationInput`}
 height="30px"
/>
</div>
</div>
</div>
<fromFlow.When is={appointmentOverlayAppointmentTypeIdValueData}>
<div
  data-testid="Content.Vertical:8"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical5}`}
>
<div
  data-testid="Content.Vertical:9"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical6}`}
>
<DateSelect
  viewPath={`${viewPath}/DateSelect`}
/>
<LocationSelect
  viewPath={`${viewPath}/LocationSelect`}
/>
</div>
<SlotSelect
  viewPath={`${viewPath}/SlotSelect`}
/>
<fromFlow.When is={tabSchedulingUntemplatedSlotDateValueData}>
<div
  data-testid="Content.Vertical:10"
  data-view-path={viewPath}
 className="views-block"
>
<UntemplatedSlot
  viewPath={`${viewPath}/UntemplatedSlot`}
/>
</div>
</fromFlow.When>
</div>
</fromFlow.When>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
<Options
  viewPath={`${viewPath}/Options`}
/>
<NotesInput
  viewPath={`${viewPath}/NotesInput`}
/>
</div>
</fromFlow.When>
{children}
</React.Fragment>)
}